import { refElements } from './elementUtils'

export const textStyleStructure = {
  layout: {
    basic: [
      'size',
      'margin',
      'padding',
      'alignment',
    ],
    advance: [
      'display',
      'overflow',
    ],
  },
  typography: {
    basic: [
      'fontWeight',
      'fontSize',
      'textTransform',
      'alignment',
      'fontStyle',
      'lineHeight',
      'fontFamily',
      'colorTheme',
      'sizeTheme',
    ],
    advance: [
      'textDecoration',
      'letterSpacing',
      'colorCustom',
    ],
  },
}

export const buttonStyleStructure = {
  layout: {
    basic: [
      'size',
      'margin',
      'padding',
      'alignment',
    ],
  },
  typography: {
    basic: [
      'fontWeight',
      'fontSize',
      'textTransform',
      'alignment',
      'fontStyle',
      'lineHeight',
      'fontFamily',
      'colorTheme',
      'sizeTheme',
    ],
    advance: [
      'textDecoration',
      'letterSpacing',
      'colorCustom',
    ],
  },
}
export const blockStyleStructure = {
  layout: {
    basic: [
      'size',
      'margin',
      'padding',
      'alignment',
    ],
    advance: [
      'display',
      'overflow',
    ],
  },
}

export const dividerStyleStructure = {
  layout: {
    basic: [
      'margin',
      'padding',
    ],
  },
  typography: {
    basic: [
      'fontFamily',
      'fontWeight',
      'fontSize',
      'lineHeight',
      'textTransform',
      'letterSpacing',
      'fontStyle',
      'colorTheme',
    ],
    advance: [
      'colorCustom',
    ],
  },
}

export const imageStyleStructure = {
  layout: {
    basic: [
      'size',
      'margin',
      'padding',
    ],
  },
}

export const columnsStyleStructure = {
  layout: {
    basic: [
      'margin',
      'padding',
    ],
  },
}

export const cardStyleStructure = {
  layout: {
    basic: [
      'size',
    ],
  },
}

export const elementStyleStructure = {
  [refElements.COLUMNS]: columnsStyleStructure,
  [refElements.SECTION]: blockStyleStructure,
  [refElements.DIV]: blockStyleStructure,
  [refElements.CONTAINER]: textStyleStructure,
  [refElements.TEXT]: textStyleStructure,
  [refElements.CARD]: cardStyleStructure,
  [refElements.IMAGE]: imageStyleStructure,
  [refElements.BUTTON]: buttonStyleStructure,
  [refElements.DIVIDER]: dividerStyleStructure,
  [refElements.CATEGORY_MENUS]: imageStyleStructure,
  [refElements.IMAGE_CAROUSEL]: imageStyleStructure,
  [refElements.CARD_GROUP]: cardStyleStructure,
  [refElements.COUNT_DOWN]: textStyleStructure,
  [refElements.YOUTUBE]: blockStyleStructure,
  [refElements.TEXT_EDITOR]: blockStyleStructure,
}


// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/utils/styleStructureUtils.js